export default __webpack_public_path__ + "static/media/gift.ec4fbb7f.svg";